import Text from '~/common/components/Texts/Text';

import type { LiabilityRecord } from '../hooks';

export function LiabilityDeleteMessageDialog({
  rows,
}: Readonly<{ rows: LiabilityRecord[] }>) {
  if (rows.length === 0) {
    return null;
  }

  if (rows.length > 1) {
    return (
      <div>
        <Text textAlign="start">
          Are you sure you want to remove these liabilities?
        </Text>
        <ul>
          {rows.map((row) => (
            <li key={row.accountNumber}>{`${row.creditorName}${
              row.accountNumber ? ` - ${row.accountNumber}` : ''
            }`}</li>
          ))}
        </ul>
      </div>
    );
  }

  const accountSuffix = rows[0].accountNumber
    ? ` - ${rows[0].accountNumber}`
    : '';

  return (
    <div>
      <Text textAlign="start">
        Are you sure you want to remove this liability: {rows[0].creditorName}
        {accountSuffix}?
      </Text>
    </div>
  );
}
